<template>
  <div class="order-pay">
    <nav-header></nav-header>
    <!-- 主体 -->
    <div class="wrapper">
      <div class="container">

        <div class="banner">
          <img src="/imgs/pay-banner.jpg" alt="">
        </div>


        <!-- 支付方式 -->
        <div class="item-pay">
          <h3>网站VIP会员</h3>
          <div class="pay-way">
            <p>￥29.9元/月</p>
            <div class="pay pay-ali" :class="{ checked: payType == 1 }"  @click="gopay()"></div>
            <!-- <div class="pay pay-wechat" :class="{ checked: payType == 2 }" @click="paySubmit(2)"></div> -->
          </div>
        </div>

        <!-- 提交信息容器 -->
        <div class="order-wrap">
          <!-- 提交信息 -->
          <div class="item-order">
            <!-- 图标 -->
            <!-- <div class="icon-succ"></div> -->
            <!-- 信息 -->
            <div class="order-info">
              <h2>VIP购买 声明</h2>
              <p>上海悠闲猫网络科技有限公司<span style="margin:0 5px;">不承担任何交易损失</span>请谨慎判断相关信息的真实性</p>
            </div>
          </div>
        </div>

      </div>
    </div>
    <nav-footer></nav-footer>
    <modal title="网站VIP会员" btnType="1" modalType="middle" :showModal="showModal" @submit="showModal = false"
      @cancel="showModal = false">
      <template v-slot:body>
        <img style="display: flex; justify-content: center; margin: 0 auto" src="/imgs/pay2.png" />
        <h2>￥29.9元/月</h2>
      </template>
    </modal>
  </div>
</template>

<script>
import NavFooter from "./../components/NavFooter";
import NavHeader from "./../components/NavHeader";
import Modal from "./../components/Modal";
export default {
  name: "pay",
  components: { NavFooter, NavHeader, Modal },
  data() {
    return {
      href: "/#/index",
      payType: 1,
      showModal: false,
    };
  },
  mounted() {
    document.title = "上海悠闲猫网络科技有限公司";
  },
  methods: {
    paySubmit(payType) {
      this.payType = payType;
    },
    // 收费逻辑
    gopay() {
      alert('请使用支付宝扫码付费~');
      this.showModal = true;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.order-pay {
  margin-top: 80px;
  background: #e4eaf6;
  box-sizing: border-box;

  .wrapper {
    padding-top: 30px;
    padding-bottom: 61px;

    .banner {
      text-align: center;
    }

    // 提交信息容器
    .order-wrap {
      padding: 30px;
      transition: all .2s ease;
      box-shadow: 0 10px 15px rgba(0, 0, 0, 0.04);
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.36), rgba(255, 255, 255, 0.2));
      background-size: auto;
      background-size: 100% 100%;
      border-radius: 20px;
      border: 1px solid rgba(255, 255, 255, 0.6);
      text-align: left;
      margin: 30px 0;

      // 提交细节
      .item-order {
        display: flex;
        align-items: center;

        // 图标
        .icon-succ {
          width: 90px;
          height: 90px;
          border-radius: 50%;
          background: url("/imgs/icon-gou.png") #80c58a no-repeat center;
          background-size: 60px;
          margin-right: 40px;
        }

        // 信息
        .order-info {
          margin-right: 248px;

          h2 {
            font-size: 24px;
            color: #333333;
            margin-bottom: 20px;
          }

          p {
            color: #666666;

            span {
              color: #ff6700;
            }
          }
        }

        // 价格
        .order-total {
          &>p:first-child {
            margin-bottom: 30px;
          }

          span {
            font-size: 28px;
            color: #ff6700;
          }

          .icon-down {
            display: inline-block;
            width: 14px;
            height: 10px;
            background: url("/imgs/icon-down.png") no-repeat center;
            background-size: contain;
            margin-left: 9px;
            transition: all 0.5s;
            cursor: pointer;

            &.up {
              transform: rotate(180deg);
            }
          }

          .icon-up {
            transform: rotate(180deg);
          }
        }
      }

      // 订单细节
      .item-detail {
        border-top: 1px solid #d7d7d7;
        padding-top: 47px;
        padding-left: 130px;
        font-size: 14px;
        margin-top: 45px;

        .item {
          margin-bottom: 19px;

          .detail-title {
            float: left;
            width: 100px;
          }

          .detail-info {
            display: inline-block;

            img {
              width: 30px;
              vertical-align: middle;
            }
          }
        }
      }
    }

    // 支付方式
    .item-pay {
      padding: 30px;
      transition: all .2s ease;
      box-shadow: 0 10px 15px rgba(0, 0, 0, 0.04);
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.36), rgba(255, 255, 255, 0.2));
      background-size: auto;
      background-size: 100% 100%;
      border-radius: 20px;
      border: 1px solid rgba(255, 255, 255, 0.6);
      text-align: left;
      margin: 30px 0;

      h3 {
        font-size: 20px;
        font-weight: 200;
        color: #333333;
        padding-bottom: 24px;
        border-bottom: 1px solid #d7d7d7;
        margin-bottom: 26px;
      }

      .pay-way {
        font-size: 18px;

        .pay {
          display: inline-block;
          width: 188px;
          height: 64px;
          border: 1px solid #d7d7d7;
          cursor: pointer;

          &:last-child {
            margin-left: 20px;
          }

          &.checked {
            border: 1px solid #ff6700;
          }
        }

        .pay-ali {
          background: url("/imgs/icon-ali.png") no-repeat center;
          background-size: 103px 38px;
          margin-top: 19px;
        }

        .pay-wechat {
          background: url("/imgs/icon-wechat.png") no-repeat center;
          background-size: 103px 38px;
        }
      }
    }
  }
}
</style>
